"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFicoLabelFrom = exports.FicoLabels = void 0;
var FicoLabels;
exports.FicoLabels = FicoLabels;
(function (FicoLabels) {
  FicoLabels["Poor"] = "bad";
  FicoLabels["Average"] = "fair";
  FicoLabels["Good"] = "good";
  FicoLabels["Excellent"] = "excellent";
})(FicoLabels || (exports.FicoLabels = FicoLabels = {}));
var getFicoLabelFrom = function getFicoLabelFrom(ficoValue) {
  if (ficoValue === undefined || ficoValue === null) {
    return null;
  }
  if (ficoValue < 630) {
    return FicoLabels.Poor;
  }
  if (ficoValue < 690) {
    return FicoLabels.Average;
  }
  if (ficoValue < 720) {
    return FicoLabels.Good;
  }
  return FicoLabels.Excellent;
};
exports.getFicoLabelFrom = getFicoLabelFrom;